import React from "react";
import ReactDOM from "react-dom";

// FontAwesome 5 — bundled by webpack, no CDN, no manual file copy.
// Includes all `fa-*` icons used across SocialMedia, the page-up arrow,
// skill icons, etc.
import "@fortawesome/fontawesome-free/css/all.min.css";

import "./index.css";
import App from "./App";

// Belt-and-suspenders for Chrome auto-translate: even though index.html ships
// with <html lang="en" dir="ltr">, a previously cached SPA bundle, a browser
// extension, or a stale service worker can leave the live <html> tagged as
// another language and break translate detection. Re-assert the locale once
// on boot before React paints.
if (typeof document !== "undefined") {
  document.documentElement.lang = "en";
  document.documentElement.dir = "ltr";
}

ReactDOM.render(<App />, document.getElementById("root"));
